import type { ReactNode, SVGProps } from "react";

export function ArrowUpIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="5"
			viewBox="0 0 8 5"
			width="8"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M3.99851 1.50727L0.973579 4.81645C0.749679 5.06118 0.387639 5.06118 0.166128 4.81645C-0.0553829 4.57171 -0.0553829 4.17596 0.166128 3.93122L3.5936 0.182035C3.81035 -0.0548942 4.15809 -0.0601033 4.38199 0.163808L7.83327 3.92862C7.94522 4.05099 8 4.21241 8 4.37123C8 4.53005 7.94522 4.69147 7.83327 4.81384C7.60938 5.05858 7.24734 5.05858 7.02583 4.81384L3.99851 1.50727Z"
				fill="currentColor"
			/>
		</svg>
	);
}
